import { Form, FormItem, Datepicker, Container } from '../../../components';

type FiltersEnum = 'started_at' | 'ended_at' | 'countries';

type FilterProps = {
  values: Record<FiltersEnum, any>;
  onChange: (newValues: Record<FiltersEnum, any>) => void;
};

export const Filter: React.FC<FilterProps> = ({ values, onChange }) => {
  return (
    <Form initialValue={values} onChange={onChange}>
      <Container className="space-y-md p-0 w-full">
        <div className="grid grid-cols-1 gap-md">
          <FormItem inline={false} name="started_at" label="Start Date">
            <Datepicker />
          </FormItem>

          <FormItem inline={false} name="ended_at" label="End Date">
            <Datepicker cleanOnDisable />
          </FormItem>
        </div>
      </Container>
    </Form>
  );
};
